/**
 * esc_order.ts — WHO OWNS AN ESCAPE PRESS (client sweep 2026-10-05, C1/C2/G1/G2). PURE.
 *
 * The Options menu's capture-phase Esc handler arbitrates before any panel's own. The order, first match wins:
 *   1. a chart (space / galaxy map) owns it                         → yield
 *   2. a text field has focus                                       → yield
 *   3. the Options menu is open                                     → close it
 *   4. the placement map owns it                                    → yield
 *   5. a CINEMATIC is playing (DeviceModule's skip owns the press)  → yield  (C2: Esc used to skip AND open Options)
 *   6. Esc is releasing the canvas pointer lock                     → yield
 *   7. an account form (#login) or another modal `.show` is up      → yield  (it closes itself; C1: #auth-banner is NOT one)
 *   8. a nav window with a × is open — the one the pad's B closes   → close that window  (G2)
 *   9. otherwise                                                    → open Options
 */
export interface EscState {
  chartOpen: boolean;
  typing: boolean;
  optionsOpen: boolean;
  placementView: boolean;
  cinematic: boolean;
  pointerLocked: boolean;
  /** `#login.show`, or any other non-HUD `.show` panel (the always-on #wallet / #pulse / #auth-banner are excluded by the caller). */
  modalShown: boolean;
  /** A visible `[data-atlas-nav]` window carrying a `[data-atlas-close]` exists. */
  windowCloseable: boolean;
}
export type EscAction = 'yield' | 'close-options' | 'close-window' | 'open-options';

export function escOwner(s: EscState): EscAction {
  if (s.chartOpen || s.typing) return 'yield';
  if (s.optionsOpen) return 'close-options';
  if (s.placementView || s.cinematic || s.pointerLocked || s.modalShown) return 'yield';
  if (s.windowCloseable) return 'close-window';
  return 'open-options';
}

/** The `.show` panels that do NOT block Esc: permanent HUD strips and the claim banner (a Later button is its only exit). */
export const ESC_SHOW_EXCLUDE = ':not(#wallet):not(#pulse):not(#auth-banner)';
